<template>
	<vx-card
		no-shadow
		card-border
		class="custom-height"
		:title="title ? $t('VisitPoints.AssignedVisitPoints') + ' ' + assignedVisitPoints.length : ''"
	>
		<template v-if="configColumns" slot="actions">
			<div class="flex flex-row justify-between">
				<vx-tooltip
					class="cursor-pointer"
					color="primary"
					position="bottom"
					delay=".1s"
					:title="$t('VisitPoints.AssignVisitPoints')"
					:text="$t('VisitPoints.AssignVisitPointToltip')"
				>
					<vs-button
						class="ml-1"
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-plus"
						@click.prevent="visitPointMounted = true"
					></vs-button>
				</vx-tooltip>
				<vx-tooltip
					class="cursor-pointer"
					color="primary"
					position="bottom"
					delay=".1s"
					:title="$t('Crud.Delete')"
					:text="$t('VisitPoints.DeleteAllVisitPoints')"
				>
					<vs-button
						v-if="remove"
						class="ml-1"
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-trash"
						@click.stop="openDeleteAllConfirm"
						v-show="assignedVisitPoints.length > 0"
					></vs-button>
				</vx-tooltip>

				<vs-dropdown vs-custom-content :vs-trigger-click="false" class="cursor-pointer">
					<vs-button
						class="ml-1"
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-layout"
					></vs-button>
					<vs-dropdown-menu :style="{width: windowWidth > 620 ? '30%' : '50%'}">
						<vx-card no-shadow :title="$t('AssignedTeams.Columns')">
							<p>{{ $t("AssignedTeams.ColumnsText") }}</p>
							<ul :class="{'demo-alignment': windowWidth > 620}">
								<li>
									<vs-checkbox v-model="checkBoxID">ID</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxIdentification" disabled>{{
										$t("Routing.Table.Identification")
									}}</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxAddress">{{
										$t("ResourceModule.Table.Address")
									}}</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxDepartment">{{
										$t("ResourceModule.Table.Department")
									}}</vs-checkbox>
								</li>
								<li>
									<vs-checkbox v-model="checkBoxCity">{{
										$t("ResourceModule.Table.City")
									}}</vs-checkbox>
								</li>
							</ul>
						</vx-card>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>
		</template>

		<vue-perfect-scrollbar class="scroll-area" :settings="settings">
			<vs-table
				max-items="100"
				pagination
				:data="assignedVisitPointsFilter"
				search
				v-if="assignedVisitPointsFilter.length > 0"
			>
				<template slot="thead">
					<vs-th v-show="checkBoxID">ID</vs-th>
					<vs-th>{{ $t("Routing.Table.Identification") }}</vs-th>
					<vs-th v-if="isDemand">{{ $t("Routing.Table.Demand") }}</vs-th>
					<vs-th v-if="isTypeService">{{ $t("TypeOfService") }}</vs-th>
					<vs-th v-show="checkBoxAddress">{{ $t("ResourceModule.Table.Address") }}</vs-th>
					<vs-th v-show="checkBoxDepartment">{{ $t("ResourceModule.Table.Department") }}</vs-th>
					<vs-th v-show="checkBoxCity">{{ $t("ResourceModule.Table.City") }}</vs-th>
					<vs-th>{{ $t("BreakTable.Action") }}</vs-th>
				</template>

				<template slot-scope="{data}">
					<vs-tr :key="indextr" v-for="(tr, indextr) in data">
						<vs-td v-show="checkBoxID" :data="data[indextr].id">
							{{ data[indextr].id }}
						</vs-td>
						<vs-td :data="data[indextr].id">
							{{ data[indextr].identification }}
						</vs-td>
						<vs-td v-if="isDemand" :data="data[indextr].id">
							<span v-if="!data[indextr].isEditDemand" @click.prevent="editCellDemand(data[indextr])">
								<span style="padding-left: 4px; margin-right: 10px">{{ data[indextr].demand }}</span>
								<span :title="$t('Edit')" style="height: 30px">🖉</span>
							</span>
							<div v-else>
								<vs-input
									v-model="data[indextr].demand"
									type="number"
									ref="inputDemand"
									@keydown="onKeyDown($event, data[indextr])"
								/>
							</div>
						</vs-td>
						<vs-td v-if="isTypeService" :data="data[indextr].id">
							<span
								v-if="!data[indextr].isEditTypeService"
								@click.prevent="editCellTypeService(data[indextr])"
							>
								<span style="padding-left: 4px; margin-right: 10px">{{
									data[indextr].typeService === "PICKUP"
										? $t("PICKUP")
										: data[indextr].typeService === "DELIVERY"
										? $t("DELIVERY")
										: data[indextr].typeService === $t("PICKUP") ||
										  data[indextr].typeService === $t("DELIVERY")
										? data[indextr].typeService
										: data[indextr].typeService.label
								}}</span>
								<span :title="$t('Edit')" style="height: 30px">🖉</span>
							</span>
							<div v-else>
								<vx-card no-shadow>
									<div class="flex justify-start items-center" style="align-items: center">
										<v-select
											v-model="data[indextr].typeService"
											class="mr-2"
											:options="serviceTypeList"
											:dir="$vs.rtl ? 'rtl' : 'ltr'"
											:clearable="false"
										>
											<template v-slot:no-options="{search, searching}">
												<template v-if="searching">
													{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
												</template>
												<template v-else>
													{{ $t("NoResultsFound") }}
												</template>
											</template>
										</v-select>
										<span
											:title="$t('Edit')"
											style="cursor: pointer"
											@click.prevent="data[indextr].isEditTypeService = false"
											>✅</span
										>
									</div>
								</vx-card>
							</div>
						</vs-td>
						<vs-td v-show="checkBoxAddress" :data="data[indextr].id">
							{{ data[indextr].address | capitalize }}
						</vs-td>
						<vs-td v-show="checkBoxDepartment" :data="data[indextr].id">
							{{ data[indextr].department }}
						</vs-td>
						<vs-td v-show="checkBoxCity" :data="data[indextr].id">
							{{ data[indextr].city }}
						</vs-td>
						<vs-td :data="data[indextr].id">
							<feather-icon
								v-if="remove"
								:title="$t('Crud.Delete')"
								size="small"
								icon="TrashIcon"
								svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
								@click="removeAssignedVisitPoint(data[indextr].id)"
							/>

							<feather-icon
								v-if="redirect"
								:title="$t('View') + ' ' + $t('Information')"
								size="small"
								icon="ExternalLinkIcon"
								svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
								class="ml-2"
								@click="goTo(data[indextr].id)"
							/>
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>

			<p v-else>
				{{ $t("VisitPoints.NoAssignedVisitPoints") }}
			</p>
		</vue-perfect-scrollbar>

		<!-- VISIT POINT LIST COMPONENT -->
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="$t('VisitPoints.ListVisitPoint')"
			:active.sync="visitPointMounted"
		>
			<visit-point-list
				v-if="visitPointMounted"
				ref="VisitPointList"
				class="mt-8"
				:customConfig="visitPointListConfig"
				:status_id="status_id"
				@getAdditionalInfo="getAdditionalInfoEmit"
			>
				<div class="is-stuck" style="background: white">
					<vx-card
						ref="filterCard"
						:title="$t('Filters')"
						class="user-list-filters mb-8"
						no-shadow
						card-border
					>
						<template slot="actions">
							<div class="form-header-inner">
								<div v-if="isDemand || isTypeService">
									<vs-dropdown
										v-if="getCheckedVisitPoints.length > 0"
										vs-custom-content
										vs-trigger-click
										class="cursor-pointer"
										:title="$t('VisitPoints.MassiveActionsVisitPoints')"
									>
										<vs-button icon-pack="feather" icon="icon-settings">
											{{ windowWidth > 620 ? $t("BreakTable.Action") : null }}
											<vs-icon class="" icon="expand_more"></vs-icon>
										</vs-button>
										<vs-dropdown-menu>
											<span style="font-weight: 700; font-size: 1rem; padding-left: 5px">
												{{ $t("Crud.Update") + " " + $t("Routing.Title.VisitPoints") }}
											</span>
											<vs-collapse accordion>
												<vs-collapse-item v-if="isTypeService">
													<div slot="header">
														<span style="font-weight: 500; font-size: 1rem">{{
															$t("TypeOfService")
														}}</span>
													</div>
													<div class="flex justify-between items-center">
														<vx-card no-shadow>
															<v-select
																v-model="serviceType"
																class="w-full mb-2"
																:options="serviceTypeList"
																:dir="$vs.rtl ? 'rtl' : 'ltr'"
																:clearable="false"
															>
																<template v-slot:no-options="{search, searching}">
																	<template v-if="searching">
																		{{ $t("NoResultsFoundFor") + " "
																		}}<em>{{ search }}</em>
																	</template>
																	<template v-else>
																		{{ $t("NoResultsFound") }}
																	</template>
																</template>
															</v-select>
															<vs-button
																class="float-right"
																width="100%"
																color="success"
																type="border"
																@click.prevent="updateService(serviceType)"
															>
																{{ $t("Apply") }}
															</vs-button>
														</vx-card>
													</div>
												</vs-collapse-item>
												<vs-collapse-item v-if="isDemand">
													<div slot="header">
														<span style="font-weight: 500; font-size: 1rem">{{
															$t("Routing.Table.Demand")
														}}</span>
													</div>
													<vs-input
														v-model="amount"
														class="w-full mb-2"
														type="number"
														ref="inputDemand"
														@keydown="onKeyDown($event)"
													/>
													<vs-button
														class="float-right"
														width="100%"
														color="success"
														type="border"
														@click.prevent="updateDemand(amount)"
													>
														{{ $t("Apply") }}
													</vs-button>
												</vs-collapse-item>
											</vs-collapse>
										</vs-dropdown-menu>
									</vs-dropdown>
								</div>
								<vs-button
									:size="iconSize"
									class="ml-2"
									id="btn-locate-visit-point"
									icon-pack="feather"
									icon="icon-check"
									:title="$t('VisitPoints.Assig') + ' ' + $t('Routing.Title.Selection')"
									:disabled="getCheckedVisitPoints.length <= 0"
									@click.prevent="setAssignedVisitPoint()"
									>{{
										windowWidth > 620
											? $t("VisitPoints.Assig") + " " + $t("Routing.Title.Selection")
											: null
									}}
								</vs-button>
							</div>
						</template>
						<div class="vx-row">
							<div class="vx-col w-full md:w-1/4">
								<label class="vs-input--label">{{ $t("SearchBy") }}</label>
								<v-select
									v-model="searchField"
									:clearable="false"
									:options="searchOptions"
									name="country"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
									class="md:mb-1 mb-4"
								>
									<template v-slot:no-options="{search, searching}">
										<template v-if="searching">
											{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
										</template>
										<template v-else>
											{{ $t("NoResultsFound") }}
										</template>
									</template>
								</v-select>
							</div>
							<div class="vx-col w-full md:w-1/2">
								<div class="vx-row">
									<div class="vx-col w-full md:w-1/1" v-if="searchField.value === 'AdditionalFields'">
										<div class="vx-row">
											<div class="vx-col w-full">
												<label class="vs-input--label">{{ $t("SelectAdditionalField") }}</label>
												<v-select
													v-model="additionalField"
													class="w-full"
													multiple
													:clearable="false"
													:options="additionalOptions"
													:dir="$vs.rtl ? 'rtl' : 'ltr'"
													:placeholder="$t('Select')"
												>
													<template #option="{label, value}">
														{{ label }}
														<br />
														<cite v-if="searchField !== 'label'" style="font-size: 12px">{{
															value
														}}</cite>
													</template>
													<template v-slot:no-options="{search, searching}">
														<template v-if="searching">
															{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
														</template>
														<template v-else>
															{{ $t("NoResultsFound") }}
														</template>
													</template>
												</v-select>
											</div>
										</div>
									</div>
									<div class="vx-col w-full md:w-1/1" v-else>
										<tags-input
											class="w-full mt-2 md:mt-6"
											element-id="tags"
											v-model="searchQuery"
											add-tags-on-comma
											add-tags-on-blur
											:title="$t('SearchSeparatedByCommas') + '.'"
											:placeholder="$t('Teams.Form.Add') + ' ' + searchField.label"
											:typeahead="true"
											@keyup.enter="searchAssignedVisitPoint"
										></tags-input>
									</div>
								</div>
							</div>
							<div class="vx-col w-full md:w-1/4">
								<div class="flex items-center mt-2 md:mt-6">
									<vs-button
										:size="iconSize"
										:title="$t('VisitPoints.Search')"
										class="ml-2"
										icon-pack="feather"
										icon="icon-search"
										@click.prevent="searchAssignedVisitPoint"
										>{{ windowWidth > 620 ? $t("VisitPoints.Search") : null }}
									</vs-button>
									<vs-button
										:size="iconSize"
										:title="$t('Refresh')"
										class="ml-2"
										icon-pack="feather"
										icon="icon-refresh-cw"
										@click="refreshVisitPoint"
										>{{ windowWidth > 620 ? $t("Refresh") : null }}
									</vs-button>
								</div>
							</div>
						</div>
					</vx-card>
				</div>
				<vs-divider class="d-theme-border-grey-light" />
			</visit-point-list>
		</vs-popup>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VisitPointList from "@/components/visit-point/list/VisitPointList.vue";
import moduleCommon from "@/store/common/moduleCommon.js";

const KEY_BACKSPACE = "Backspace";
const KEY_F2 = "F2";
const KEY_ENTER = "Enter";
const KEY_TAB = "Tab";
const KEY_ESC = "Escape";

export default {
	name: "AssignedVisitPointList",
	props: {
		visit_point_ids: {
			type: Array,
			default: () => [],
		},
		title: {
			type: Boolean,
			default: () => true,
		},
		add: {
			type: Boolean,
			default: () => true,
		},
		remove: {
			type: Boolean,
			default: () => true,
		},
		configColumns: {
			type: Boolean,
			default: () => true,
		},
		redirect: {
			type: Boolean,
			default: () => false,
		},
		capacities: {
			type: Array,
			default: () => [],
		},
		isDemand: {
			type: Boolean,
			default: true,
		},
		isTypeService: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		vSelect,
		VuePerfectScrollbar,
		VisitPointList,
	},
	data() {
		return {
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			visitPointMounted: false,
			visitPointListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: [
					"id",
					"identification",
					"demand",
					"typeService",
					"address",
					"city",
					"department",
					"status_name",
					"additional_info",
				],
				tableOptions: false,
				showItemsPerPage: false,
				showSearch: false,
				showActions: false,
				filterHead: false,
				cellRendererAdditionalFields: true,
				CellRendererDemand: this.isDemand,
				CellRendererTypeService: this.isTypeService,
				showPopup: true,
			},
			searchQuery: [],
			searchField: {value: "Identification", label: this.$t("Routing.Table.Identification")},
			dataSelect: [],
			additionalField: null,
			model: null,
			additional_info: {},
			searchQueryVPList: "",
			checkBoxIdentification: true,
			checkBoxAddress: true,
			checkBoxCity: false,
			checkBoxDepartment: false,
			checkBoxID: false,
			additionalOptions: [],
			valCellOldDemand: 0,
			valCellOldTypeService: "",
			amount: "",
			serviceType: {value: "PICKUP", label: this.$t("PICKUP")},
			status_id: [],
		};
	},
	async created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		await this.$store
			.dispatch("moduleCommon/fetchDataSelectVisitPoint")
			.then((res) => {
				this.status_id = res.data.status.filter((st) => st.name === "ACTIVE").map(({id}) => id);
			})
			.catch((error) => {
				console.error(error);
			});
		if (this.visit_point_ids && this.visit_point_ids.length > 0 && this.assignedVisitPoints.length <= 0) {
			this.getVisitPoint();
		}
	},
	mounted() {
		this.searchQuery = [];
	},
	computed: {
		assignedVisitPoints() {
			if (this.capacities.length > 0 && (this.isDemand || this.isTypeService)) {
				for (let visitPoint of this.$store.state.moduleVisitPoint.assignedVisitPoints) {
					for (let capacity of this.capacities) {
						if (capacity.visit_point_id === visitPoint.id) {
							visitPoint.demand = capacity.amount;
							visitPoint.typeService = capacity.job_type;
						}
					}
				}
			}
			return this.$store.state.moduleVisitPoint.assignedVisitPoints;
		},
		assignedVisitPointsFilter() {
			const data = this.$store.state.moduleVisitPoint.assignedVisitPoints;
			if (!this.searchQueryVPList || this.searchQueryVPList.trim().length <= 0) {
				return data;
			}
			return data.filter((r) => {
				return (
					r.name.toLowerCase().includes(this.searchQueryVPList.toLowerCase()) ||
					(r.id + "").includes(this.searchQueryVPList)
				);
			});
		},
		searchOptions() {
			return [
				{value: "Identification", label: this.$t("Routing.Table.Identification")},
				{value: "Address", label: this.$t("Address")},
				{value: "City", label: this.$t("City")},
				{value: "Department", label: this.$t("Divipola.Department")},
				{
					value: "AdditionalFields",
					label: this.$t("AdditionalFields"),
				},
			];
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		getCheckedVisitPoints() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoits;
		},
		serviceTypeList() {
			return [
				{value: "PICKUP", label: this.$t("PICKUP")},
				{value: "DELIVERY", label: this.$t("DELIVERY")},
			];
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		removeAssignedVisitPoint(id) {
			this.$store.commit("moduleVisitPoint/REMOVE_ASSIGNED_VISIT_POINT", id);
		},
		refreshVisitPoint() {
			this.$refs.VisitPointList.refreshVisitPoint();
			this.searchQuery = [];
			this.searchField = {value: "Identification", label: this.$t("Routing.Table.Identification")};
		},
		getVisitPoint() {
			this.openLoading();
			this.$store
				.dispatch("moduleVisitPoint/findVisitPointsAssigned", {
					order_by: ["id"],
					sort: "desc",
					id: this.visit_point_ids,
				})
				.then((res) => {
					this.$emit("finishLoadEmit", true);
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		openDeleteAllConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("VisitPoints.DeleteAllText") + ` "${this.$t("Routing.Title.VisitPoints")}"`,
				accept: this.deleteAll,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAll() {
			this.$store.commit("moduleVisitPoint/REMOVE_ALL_ASSIGNED_VISIT_POINT");
		},
		goTo(visitPointId) {
			this.$router.push(`/apps/visit-point/visit-point-view/${visitPointId}`);
		},
		getAdditionalInfoEmit(data) {
			this.additionalOptions = data.map((info) => {
				return {label: info.label, value: info.value};
			});
		},
		searchAssignedVisitPoint() {
			if (this.searchField.value === "AdditionalFields") {
				this.searchQuery = [];
				this.additionalField.forEach((field) => {
					this.searchQuery.push({key: field.label, value: field.value});
				});
			}
			this.$refs.VisitPointList.searchAssignedVisitPoint(this.searchField.value, this.searchQuery, 1);
		},
		setAssignedVisitPoint() {
			let selectedRows = [...this.getCheckedVisitPoints];
			this.$store.commit("moduleVisitPoint/SET_ASSIGNED_VISIT_POINT", selectedRows);
			this.visitPointMounted = false;
			this.searchQuery = [];
		},
		onKeyDown(event, val) {
			if (this.isLeftOrRight(event) || this.isBackspace(event)) {
				event.stopPropagation();
				return;
			}
			if (this.isEsc(event)) {
				val.demand = this.valCellOldDemand;
				val.isEditDemand = false;
			}
			if (!this.finishedEditingPressed(event) && !this.isKeyPressedNumeric(event)) {
				if (event.preventDefault) event.preventDefault();
			} else if (this.finishedEditingPressed(event)) {
				val.isEditDemand = false;
			}
		},
		isCharNumeric(charStr) {
			return /\d/.test(charStr);
		},
		isKeyPressedNumeric(event) {
			const charStr = event.key;
			return this.isCharNumeric(charStr);
		},
		finishedEditingPressed(event) {
			const key = event.key;
			return key === KEY_ENTER || key === KEY_TAB;
		},
		isBackspace(event) {
			return event.key === KEY_BACKSPACE;
		},
		isEsc(event) {
			return event.key === KEY_ESC;
		},
		isLeftOrRight(event) {
			return ["ArrowLeft", "ArrowRight"].indexOf(event.key) > -1;
		},
		editCellDemand(data) {
			this.valCellOldDemand = data.demand;
			data.isEditDemand = true;
		},
		editCellTypeService(data) {
			let typeServiceValue;
			if (data.typeService === "PICKUP") {
				typeServiceValue = this.$t("PICKUP");
			} else if (data.typeService === "DELIVERY") {
				typeServiceValue = this.$t("DELIVERY");
			} else if (data.typeService === this.$t("PICKUP") || data.typeService === this.$t("DELIVERY")) {
				typeServiceValue = data.typeService;
			} else {
				typeServiceValue = data.typeService.label;
			}
			data.typeService = typeServiceValue;
			this.valCellOldTypeService = data.typeService;
			data.isEditTypeService = true;
		},
		updateDemand(amount) {
			if (amount !== undefined && amount !== null && amount !== "" && amount > 0) {
				this.$refs.VisitPointList.updateDemand(amount);
				this.amount = "";
			}
		},
		updateService(type) {
			this.$refs.VisitPointList.updateService(type.value);
			this.serviceType = {value: "PICKUP", label: this.$t("PICKUP")};
		},
	},
	watch: {
		searchField(val) {
			if (val.value !== "AdditionalFields") {
				this.additionalField = null;
			}
		},
		visitPointMounted(val) {
			if (!val) {
				this.additional_info = null;
				this.model = null;
				this.additionalField = null;
			}
		},
	},
	beforeDestroy() {
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_ASSIGNED_VISIT_POINT");
	},
};
</script>

<style lang="scss" scoped>
#resource-create-tab-info {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 400px;
	max-height: 450px;
}

.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}

.con-vs-dropdown--menu {
	z-index: 54000 !important;
}
.is-stuck {
	position: fixed;
	top: 52px;
	inset-inline-start: 0;
	margin-inline-start: 30px;
	width: calc(100% - 80px);
	z-index: 14;
}
.form-header-inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>
